import { useCallback, useEffect } from 'react'
import { observer } from 'mobx-react'

import { ScrollToTop } from 'Components/ScrollToTop/ScrollToTop'

import { useStore } from 'Stores/index'
import { OrderStepEnum } from 'Stores/orderStore/orderStore.types'

import { OrderSummary } from '../../OrderSummary/OrderSummary'
import { SummaryStepProps } from '../Steps.types'

export const SummaryStep = observer((props: SummaryStepProps) => {
  const {
    setCurrentOrderStep,
    handleOrderSubmit,
    isSubmitLoading,
    activeEmployeeId,
    handlePreviousStep,
    isEarlyUpgrade,
    isNewOrder,
  } = props
  const { orderStore, rentalStore } = useStore()
  const { rentalDetails } = rentalStore
  const {
    chosenShippingAddress,
    chosenAccessories,
    netPriceCalculator,
    setNetPriceCalculator,
    chosenDevice,
    remarks,
    setRemarks,
    getTotalPrice,
    setAccessoryLabel,
    setAccessoryQuantity,
    setChosenDeviceLabel,
    setChosenDeviceQuantity,
    setCurrentStep,
    orderDevices,
  } = orderStore

  const totalPrice = getTotalPrice || {
    totalBasis: 0,
    totalCalculatedNet: 0,
    totalWithTax: 0,
    totalWithoutTax: 0,
  }

  const handlePreviousAction = useCallback(() => {
    if (handlePreviousStep) {
      handlePreviousStep()
    }
  }, [handlePreviousStep])

  useEffect(() => {
    setCurrentStep(OrderStepEnum.summary)
  }, [setCurrentStep])

  return (
    <>
      <ScrollToTop />

      <OrderSummary
        activeEmployeeId={activeEmployeeId}
        chosenAccessories={chosenAccessories}
        chosenDevice={chosenDevice}
        chosenShippingAddress={chosenShippingAddress}
        earlyUpgradeFee={rentalDetails?.rental.upgradeAmount || 0}
        isEarlyUpgrade={isEarlyUpgrade}
        isLoading={isSubmitLoading}
        isNewOrder={isNewOrder}
        onBackButtonClick={handlePreviousAction}
        onChangeDeviceButtonClick={() => {
          setNetPriceCalculator({
            ...netPriceCalculator,
            collapse: false,
          })

          if (setCurrentOrderStep) {
            setCurrentOrderStep(1)
          }
        }}
        onOrderButtonClick={handleOrderSubmit}
        onSetAccessoryLabel={(label, accessory) => {
          setAccessoryLabel(label, accessory)
        }}
        onSetAccessoryQuantity={(quantity, accessory) => {
          setAccessoryQuantity(quantity, accessory)
        }}
        onSetChosenDeviceLabel={label => {
          setChosenDeviceLabel(label)
        }}
        onSetChosenDeviceQuantity={quantity => {
          setChosenDeviceQuantity(quantity)
        }}
        orderDeviceResponseVariant={orderDevices?.variant}
        remarks={remarks}
        setRemarks={(remarks: string) => setRemarks(remarks)}
        totalPrice={totalPrice}
      />
    </>
  )
})
